export enum AutomationServicesNameEnum {
  FMC = 'Flight Movement Configuration',
  PYC = 'Payment Configuration'
}
